// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__tZleD","left":"ModalHeader_left__CJ-zu","title":"ModalHeader_title__9WFn7","sub":"ModalHeader_sub__+KYaJ"};